import { Container, Reveal, RevealGroup } from '@/components/common'
import type { Programme } from '@/types/programmes'
import { programmes } from '@/constants/programmes'

const ProgrammeRow = ({ pillar, title, description, highlights, image }: Programme) => (
  <article className="group grid items-center gap-8 border-t border-border py-14 lg:grid-cols-12 lg:gap-12">
    <div className="lg:col-span-6">
      <div className="flex items-center gap-4">
        <span className="inline-flex items-center rounded-full bg-surface px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.2em] text-ibon-dark">
          {pillar}
        </span>
      </div>

      <h3 className="mt-6 text-2xl font-bold leading-snug tracking-tight text-ibon-dark lg:text-3xl">
        {title}
      </h3>
      <p className="mt-4 max-w-xl text-base leading-relaxed text-text-muted">{description}</p>

      <ul className="mt-7 flex flex-wrap gap-3">
        {highlights.map((item) => (
          <li
            key={item}
            className="inline-flex items-center gap-2 rounded-full border border-border px-4 py-2 text-xs font-medium text-ibon-dark"
          >
            <span className="size-1.5 rounded-full bg-ibon-sky" />
            {item}
          </li>
        ))}
      </ul>
    </div>

    <div className="overflow-hidden lg:col-span-6">
      <img
        src={image}
        alt={title}
        className="aspect-16/10 w-full object-cover transition-transform duration-700 group-hover:scale-105"
        loading="lazy"
      />
    </div>
  </article>
)

export const ProgrammesList = () => {
  return (
    <section className="bg-white py-24 lg:py-32">
      <Container>
        <div className="max-w-3xl">
          <Reveal variant="up" delay={100}>
            <h2 className="mt-7 text-4xl font-bold leading-[1.02] tracking-[-0.02em] text-ibon-dark sm:text-5xl lg:text-6xl">
              Programmes built on the <span className="text-ibon-dark/30">BEC framework.</span>
            </h2>
          </Reveal>
        </div>

        <RevealGroup className="mt-12 flex flex-col" step={120}>
          {programmes.map((programme) => (
            <ProgrammeRow key={programme.title} {...programme} />
          ))}
        </RevealGroup>
      </Container>
    </section>
  )
}
